import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmVolumeX = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon-llm-volume-x",
    "data-icon": "icon-llm-volume-x",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsx("polygon", {
      points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }), jsx("line", {
      x1: "22",
      y1: "9",
      x2: "16",
      y2: "15"
    }), jsx("line", {
      x1: "16",
      y1: "9",
      x2: "22",
      y2: "15"
    })]
  }));
});
IconLlmVolumeX.displayName = 'IconLlmVolumeX';

export { IconLlmVolumeX };
//# sourceMappingURL=llm-volume-x.js.map
